import request from '../../utils/request';

const updateEnrollment = (payload, enrollmentId) =>
  request({
    url: `/enrollment/${enrollmentId}`,
    method: 'PATCH',
    data: { ...payload },
  });

const finishEnrollmentForm = () =>
  request({
    url: `/enrollment/finish/finishEnrollment`,
    method: 'PATCH',
  });

export default { updateEnrollment, finishEnrollmentForm };
